import * as React from "react";
import { Link } from "react-router-dom";
import Loader from "../../../components/atoms/Loader";
import TabsNavi from "../../../components/molecules/TabsNavi";
import { KarteTemplateInterface } from "../../../interfaces/KarteTemplateInterface";
import SectionInterface from "../../../interfaces/SectionInterface";
import KarteTemplateList from "./KarteTemplateList";
import styles from "./styles.scss";

interface Props {
  section: SectionInterface;
  karteTemplates: KarteTemplateInterface[];
  isLoading: boolean;
}

const SectionsSettingsKarteTemplates = (props: Props) => {
  return (
    <React.Fragment>
      <TabsNavi
        tabs={[
          {
            label: "テンプレート",
            link: `/sections/${props.section.id}/settings/karte_templates`,
            active: true,
          },
          ...(props.section.aiAssistantAvailable
            ? [
                {
                  label: "AIアシスタント",
                  link: `/sections/${props.section.id}/settings/ai_assistant_templates`,
                  active: false,
                },
              ]
            : []),
        ]}
      />
      <div className={styles.newLink}>
        <Link
          to={`/sections/${props.section.id}/settings/karte_templates/new`}
          className={`buiButtonBase buiButtonVariantFilled ${styles.Btn}`}
        >
          新規作成
        </Link>
      </div>
      <div className={styles.tableWrapper}>
        <KarteTemplateList
          sectionId={props.section.id}
          karteTemplates={props.karteTemplates}
        />
      </div>
      <Loader loading={props.isLoading} />
    </React.Fragment>
  );
};

export default SectionsSettingsKarteTemplates;
